import React from "react";
import { Spinner } from "react-bootstrap";

const LoadingButton = () => {
  return <Spinner animation="border" variant="grey" size="sm" />;
};

export default LoadingButton;
